/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_ProviderInputs */



/**
* | output |
* | --- |
* | "Service Provider" |
*
* @param {Service_ProviderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const service_provider = /** @type {((inputs?: Service_ProviderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_ProviderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fournisseur de service")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dienstleister")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fornitore di servizi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поставщик услуг")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proveedor de servicios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("服务提供商")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サービスプロバイダー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेवा प्रदाता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prestador de Serviços")
	return /** @type {LocalizedString} */ ("Service Provider")
});